import { CountryISO } from 'ngx-intl-tel-input-gg';

export interface CountryItem {
  name: string;
  value: string;
}

const cache = new Map<string, CountryItem[]>();

/**
 * Builds the country list for manual address entry.
 * Names are resolved through the native Intl.DisplayNames so they follow the active
 * language, while the stored value stays an uppercase ISO2 code — the same format
 * mapAddressComponentToAddress produces from Google's shortText.
 * The result is cached per locale: constructing Intl.DisplayNames is expensive, so it is
 * built once per locale rather than once per country, and reused on subsequent calls.
 */
export const buildCountryItems = (locale: string): CountryItem[] => {
  const cached = cache.get(locale);
  if (cached) return cached;

  const displayNames = new Intl.DisplayNames([locale], { type: 'region' });
  const items = Object.values(CountryISO)
    .map((iso) => {
      const code = iso.toUpperCase();
      return { name: displayNames.of(code) ?? code, value: code };
    })
    .sort((a, b) => a.name.localeCompare(b.name, locale));

  cache.set(locale, items);
  return items;
};
